// extracted by mini-css-extract-plugin
export var table = "_yf-0";